import { IChatConversation } from 'src/@types/chat';
import { PATH_DASHBOARD } from 'src/Router/paths';
import { NavItem } from 'src/features/Navbar/NavItem';
import useActiveLink from 'src/hooks/useActiveLink';
import Iconify from '../../../../components/iconify';

type Props = {
  conversation: IChatConversation;
};
export const ChatNavItemSubChannel = ({ conversation }: Props) => {
  const path = PATH_DASHBOARD.chat.subchannel(
    conversation.parentId as string,
    conversation._id,
  );
  const { active } = useActiveLink(path, false);

  return (
    <NavItem
      highlight={!!conversation.unreadMessages?.length}
      badgeContent={conversation.unreadMessages?.length}
      depth={1}
      path={path}
      sx={{
        ml: 1.5,
        width: 'unset',
      }}
      icon={<Iconify icon="tabler:timeline-event-text" />}
    >
      {conversation?.threadNumber
        ? `Thread #${conversation?.threadNumber}`
        : 'Thread'}
    </NavItem>
  );
};
